













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import GenericDropdown from '@/components/GenericDropdown.vue';                       // @ is an alias to /src
import MomentSoldOSListComponent from '@/components/MomentSoldOSListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { MomentSold, sortOrderTypes } from '@/MomentSold'
import { OddSalesList } from '@/OddSalesList'
import { IPaginationResult } from '@/PaginationResult'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'OddSales',
  components: { GenericDropdown, MomentSoldOSListComponent, ModalWrapperComponent }
})

export default class OddSalesComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public sellerAddress: string

  @Prop()
  public buyerAddress: string

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: MomentSold[] = []
  public osList: OddSalesList = null
  public paginationResult: IPaginationResult = null
  public numMoments: number = null

  // UI and filter options
  public seller: { label: string, flowAddress: string } = { label: 'Top odd sellers', flowAddress: null }
  public sellers: Array<{ label: string, flowAddress: string }> = []
  public buyer: { label: string, flowAddress: string } = { label: 'Top odd buyers', flowAddress: null }
  public buyers: Array<{ label: string, flowAddress: string }> = []

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  @Watch('seller')
  public async onChangedSeller(user: { label: string, flowAddress: string }) {
    if (this.$store.state.devmode) console.log(`onChangedSeller()`)
    this.seller = user ? user : { label: 'Top odd sellers', flowAddress: null }
    this.moments = []
    this.numMoments = 0
    this.pageNumberToLoadNext = 1
    this.sellerAddressToUseWhenReady = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  @Watch('buyer')
  public async onChangedBuyer(user: { label: string, flowAddress: string }) {
    if (this.$store.state.devmode) console.log(`onChangedBuyer()`)
    this.buyer = user ? user : { label: 'Top odd buyers', flowAddress: null }
    this.moments = []
    this.numMoments = 0
    this.pageNumberToLoadNext = 1
    this.buyerAddressToUseWhenReady = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }  

  public async onClickedSeller(flowAddress: string) {
    let foundOneInExistingList: boolean
    if (this.$store.state.devmode) console.log(`onClickedSeller()`)
    for (const seller of this.sellers) {
      if (seller.flowAddress === flowAddress) {
        foundOneInExistingList = true
        this.onChangedSeller(seller)
        break;
      }
    }
    if (!foundOneInExistingList) {
      const addOne: { label: string, flowAddress: string } = { label: flowAddress, flowAddress }
      this.sellers.push(addOne)
      this.onChangedSeller(addOne)
    }
  }
  public async onClickedBuyer(flowAddress: string) {
    let foundOneInExistingList: boolean
    if (this.$store.state.devmode) console.log(`onClickedBuyer()`)
    for (const buyer of this.buyers) {
      if (buyer.flowAddress === flowAddress) {
        foundOneInExistingList = true
        this.onChangedBuyer(buyer)
        break;
      }
    }
    if (!foundOneInExistingList) {
      const addOne: { label: string, flowAddress: string } = { label: flowAddress, flowAddress }
      this.buyers.push(addOne)
      this.onChangedBuyer(addOne)
    }    
  }

  public showFAQ(): void {
    (this.$refs.FAQOddSalesComponent as ModalWrapperComponent).show('Odd Sales FAQ', 'md', null)
  }    

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private timer
  private sellerAddressToUseWhenReady: string = null
  private buyerAddressToUseWhenReady: string = null

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`OddSalesComponent.pathChanged() ${this.$route.path}`)
  }


  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    utils_tracker.page(this.$options.name)

    // from props
    this.sellerAddressToUseWhenReady = this.sellerAddress
    this.buyerAddressToUseWhenReady = this.buyerAddress

    // from route
    if (this.$route.query.seller) this.sellerAddressToUseWhenReady = this.$route.query.seller as string
    if (this.$route.query.buyer) this.buyerAddressToUseWhenReady = this.$route.query.buyer as string

    await this.fetchData(false, this.pageNumberToLoadNext)

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add flowAddresses as query params to current url path
  private addParamsToURL() {
    let extra: string = ''
    if (this.seller && this.seller.flowAddress) extra += `&seller=${encodeURIComponent(this.seller.flowAddress)}`
    if (this.buyer && this.buyer.flowAddress) extra += `&buyer=${encodeURIComponent(this.buyer.flowAddress)}`
    extra = extra.replace('&', '?')     // replace only the first one
    this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
  }

  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    const fakeMoment: MomentSold = new MomentSold(null)
    fakeMoment.momentID = 0
    fakeMoment.valueFMV = 0

    let url: string = utils.getURLprefix() + `/api/topshot/oddSales/`;
    url += `?page=${pageNumberWhenCalled}`;
    if (this.seller && this.seller.flowAddress) url += '&seller=' + encodeURIComponent(this.seller.flowAddress)
    if (this.buyer && this.buyer.flowAddress) url += '&buyer=' + encodeURIComponent(this.buyer.flowAddress)

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`OddSalesComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;

    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the userCounts from the server
      interface userCount {
        usernameSlashAddress: string,
        count: number
      }
      const sellerCounts: userCount[] = response.data.sellerCounts
      if (sellerCounts && sellerCounts.length > 0) {
        this.sellers = [ { label: 'Top odd sellers', flowAddress: null } ]
        for (const uc of sellerCounts) {
          let nameToUse: string = uc.usernameSlashAddress.split('/')[0]
          const flowAddress: string = uc.usernameSlashAddress.split('/')[1]
          if (nameToUse.length === 0) nameToUse = flowAddress
          const label: string = `${nameToUse} (${uc.count})`
          this.sellers.push( { label, flowAddress })
        }
      }
      const buyerCounts: userCount[] = response.data.buyerCounts
      if (buyerCounts && buyerCounts.length > 0) {
        this.buyers = [ { label: 'Top odd buyers', flowAddress: null } ]
        for (const uc of buyerCounts) {
          let nameToUse: string = uc.usernameSlashAddress.split('/')[0]
          const flowAddress: string = uc.usernameSlashAddress.split('/')[1]
          if (nameToUse.length === 0) nameToUse = flowAddress
          const label: string = `${nameToUse} (${uc.count})`
          this.buyers.push( { label, flowAddress })
        }
      }

      // process flowAddressToUseWhenReady if it was passed into URL
      let needToRefetch: boolean = false
      if (this.sellerAddressToUseWhenReady) {
        let foundOneInExistingList: boolean

        for (const user of this.sellers) {
          if (user.flowAddress === this.sellerAddressToUseWhenReady) {
            this.seller = user
            foundOneInExistingList = true
          }
        }
        if (!foundOneInExistingList) {
          const addOne: { label: string, flowAddress: string } = { label: this.sellerAddressToUseWhenReady, flowAddress: this.sellerAddressToUseWhenReady }
          this.sellers.push(addOne)
          this.seller = addOne
        }
        needToRefetch = true
      }
      this.sellerAddressToUseWhenReady = null

      if (this.buyerAddressToUseWhenReady) {
        let foundOneInExistingList: boolean

        for (const user of this.buyers) {
          if (user.flowAddress === this.buyerAddressToUseWhenReady) {
            this.buyer = user
            foundOneInExistingList = true
          }
        }
        if (!foundOneInExistingList) {
          const addOne: { label: string, flowAddress: string } = { label: this.buyerAddressToUseWhenReady, flowAddress: this.buyerAddressToUseWhenReady }
          this.buyers.push(addOne)
          this.buyer = addOne
        }
        needToRefetch = true
      }
      this.buyerAddressToUseWhenReady = null

      if (needToRefetch) {
        this.pageNumberToLoadNext = 1
        return await this.fetchData(false, this.pageNumberToLoadNext)
      }

      // load up subtotals
      this.numMoments = response.data.numMoments

      // load up the FastFingerList
      this.osList = new OddSalesList(response.data.osList)

      // load up the moments separately from the FastFingerList object in case we want to do paging (might do everything inside FastFingerList eventually)
      let newRawItems: MomentSold[] = response.data.osList.moments
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new MomentSold(po));
        if (pageNumberWhenCalled === 1) {
          if (newRawItems.length > 0) this.moments = [ fakeMoment ].concat(newRawItems); else this.moments = []
        } else {
          this.moments = this.moments.concat(newRawItems)
        }

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    this.$store.commit("setLoading", { loading: false });
  }  
}
